<div class="modal-backdrop" (click)="onCancel()"></div>
<div class="profile-modal">
  <div class="modal-header">
    <span class="modal-title">
      <span *ngIf="mode === 'setup'">👤 Your Profile</span>
      <span *ngIf="mode === 'create'">🎨 Create a Room</span>
      <span *ngIf="mode === 'join'">🔗 Join a Room</span>
    </span>
    <button class="modal-close" (click)="onCancel()">✕</button>
  </div>

  <div class="modal-body">
    <!-- Avatar & Color preview -->
    <div class="profile-preview">
      <div class="avatar-big" [style.background]="color">
        <img *ngIf="profilePicUrl" [src]="profilePicUrl" class="profile-pic-preview" alt="profile" />
        <span *ngIf="!profilePicUrl">{{ selectedAvatar }}</span>
      </div>
      <div class="preview-name">{{ username || 'your name' }}</div>
    </div>

    <!-- Username locked if logged in -->
    <div class="field-group">
      <label class="field-label">
        USERNAME
        <span class="locked-badge" *ngIf="isLoggedIn">🔒 locked</span>
      </label>
      <input
        class="pxl-input"
        [class.field-locked]="isLoggedIn"
        type="text"
        [(ngModel)]="username"
        placeholder="pixelwizard"
        maxlength="24"
        [readonly]="isLoggedIn">
      <span class="field-hint" *ngIf="isLoggedIn">Username is set from your account.</span>
      <span class="field-error" *ngIf="errors['username']">{{ errors['username'] }}</span>
    </div>

    <!-- Email locked if logged in -->
    <div class="field-group">
      <label class="field-label">
        EMAIL
        <span class="locked-badge" *ngIf="isLoggedIn">🔒 locked</span>
      </label>
      <input
        class="pxl-input"
        [class.field-locked]="isLoggedIn"
        type="email"
        [(ngModel)]="email"
        placeholder="you@example.com"
        [readonly]="isLoggedIn">
      <span class="field-hint" *ngIf="isLoggedIn">Email is tied to your account.</span>
      <span class="field-error" *ngIf="errors['email']">{{ errors['email'] }}</span>
    </div>

    <!-- Color -->
    <div class="field-group">
      <label class="field-label">CURSOR COLOR</label>
      <div class="color-swatches">
        <button *ngFor="let c of colorOptions"
          class="color-swatch"
          [style.background]="c"
          [class.active]="color === c"
          (click)="color = c">
        </button>
      </div>
    </div>

    <!-- Profile picture upload -->
    <div class="field-group">
      <label class="field-label">PROFILE PICTURE <span class="field-optional">(optional)</span></label>
      <div class="profile-pic-row">
        <label class="profile-pic-upload-btn" for="profilePicInput">
          📷 Upload image
          <input id="profilePicInput" type="file" accept="image/*" style="display:none"
            (change)="onProfilePicSelected($event)" />
        </label>
        <button class="btn-ghost xs danger" *ngIf="profilePicUrl" (click)="removeProfilePic()">✕ Remove</button>
      </div>
      <span class="field-hint">Max 2 MB · Replaces emoji avatar</span>
      <span class="field-error" *ngIf="errors['profilePic']">{{ errors['profilePic'] }}</span>
    </div>

    <!-- Avatar emoji (hidden if custom pic selected) -->
    <div class="field-group" *ngIf="!profilePicUrl">
      <label class="field-label">AVATAR</label>
      <div class="avatar-grid">
        <button *ngFor="let a of avatarEmojis"
          class="avatar-btn"
          [class.active]="selectedAvatar === a"
          [style.border-color]="selectedAvatar === a ? color : 'transparent'"
          (click)="selectedAvatar = a">{{ a }}</button>
      </div>
    </div>

    <!-- Room ID (join only - create auto-generates on confirm) -->
    <div class="field-group" *ngIf="mode === 'join'">
      <label class="field-label">ROOM ID</label>
      <input class="pxl-input" type="text" [(ngModel)]="roomId" placeholder="Enter room ID"
        style="text-transform:uppercase" maxlength="16">
      <span class="field-error" *ngIf="errors['roomId']">{{ errors['roomId'] }}</span>
    </div>
  </div>

  <div class="modal-footer">
    <button class="pxl-btn pxl-btn-secondary" (click)="onCancel()">Cancel</button>
    <button class="pxl-btn pxl-btn-primary" (click)="onConfirm()">
      <span *ngIf="mode === 'setup'">✓ Save Profile</span>
      <span *ngIf="mode === 'create'">🚀 Create Room</span>
      <span *ngIf="mode === 'join'">🔗 Send Join Request</span>
    </button>
  </div>
</div>
